import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import styles from './css/index.module.scss';
import PageTitle from '../../components/PageTitle';
import {
} from '../../store/actions/staticData';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../Api';
import IconButton from '../../components/IconButton';
import CancelEditingIcon from '../../assets/formIcons/cancelEditing.svg';
import ChangePhotosIcon from '../../assets/formIcons/photosSmall.svg';
import ChangeOrgIcon from '../../assets/formIcons/changeOrg.svg';
import EmptyHeight from '../../components/EmptyHeight';
import MapView from '../ViewSingleOrganization/components/MapView';

function ViewSingleEvent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('id');

  const [gettingLoading, setGettingLoading] = useState(true);
  const [gettingError, setGettingError] = useState('');
  const [singleEvent, setSingleEvent] = useState(null);

  const onCancelClick = () => {
    navigate('/events/view');
  };

  const onEditPhotoClick = () => {
    navigate(`/events/edit-photos?id=${singleEvent._id}`);
  };

  const onEditClick = () => {
    navigate(`/events/edit?id=${singleEvent._id}`);
  };

  const initData = async () => {
    const data = await sendRequest({
      request: Api.getEvent,
      payload: { id: eventId },
      warnErrorText: 'while getting single event',
      setLoading: setGettingLoading,
    });

    if (data?.status !== 'ok') {
      setGettingError(typeof data.message === 'string' ? data.message : 'Ошибка');
    }

    setSingleEvent(data.event);
  };

  useEffect(() => {
    initData().then();
  }, []);

  return (
    <div className={styles.wrapper}>
      <PageTitle
        text="Просмотр"
        RightComponent={(
          <div className={styles.buttonsRow}>
            <IconButton
              svgPath={CancelEditingIcon}
              tooltipText="Отменить"
              onClick={onCancelClick}
            />
            <IconButton
              svgPath={ChangePhotosIcon}
              tooltipText="Изменить фото"
              onClick={onEditPhotoClick}
            />
            <IconButton
              svgPath={ChangeOrgIcon}
              tooltipText="Редактировать"
              onClick={onEditClick}
            />
          </div>
        )}
      />
      {gettingLoading
        ? <p className={styles.infoText}>Загрузка</p>
        : gettingError
          ? <p className={styles.infoText}>{gettingError}</p>
          : singleEvent ? (
            <div className={styles.container}>
              <div className={styles.column}>
                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Владелец</p>
                    <p className={styles.infoTitle}>{moment(singleEvent.user.createdAt).format('DD.MM.YYYY')}</p>
                  </div>
                  <p className={styles.text}>
                    ID OWN:
                    {' '}
                    {singleEvent.user._id}
                  </p>
                  <EmptyHeight height={16} />
                  <p className={styles.text}>
                    {singleEvent.user.email}
                  </p>
                </div>

                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Описание</p>
                  </div>
                  <p className={styles.text}>
                    {singleEvent.description}
                  </p>
                </div>
              </div>

              <div className={styles.column}>
                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Местоположение</p>
                  </div>
                  <p className={styles.textBold}>
                    {singleEvent.country.name}
                  </p>
                  <EmptyHeight height={16} />
                  <p className={styles.text}>
                    {singleEvent.city.name}
                  </p>
                  {singleEvent.city?._id && singleEvent.coordinates && (
                  <>
                    <EmptyHeight height={16} />
                    <MapView
                      city={singleEvent.city}
                      coordinates={singleEvent.coordinates}
                      setCoordinates={() => {}}
                      defaultZoom={12}
                    />
                  </>
                  )}
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>{singleEvent.address}</p>
                </div>

                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Контакты</p>
                  </div>
                  <p className={styles.textGray}>Телефон</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.phone_number || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>Instagram</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.instagram || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>Telegram</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.telegram || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>WhatsApp</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.whatsapp || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>Viber</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.viber || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>Facebook</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.facebook || '____'}</p>
                  <EmptyHeight height={16} />
                  <p className={styles.textGray}>Сайт</p>
                  <EmptyHeight height={8} />
                  <p className={styles.text}>{singleEvent.contacts.website || '____'}</p>
                  <EmptyHeight height={16} />
                </div>
              </div>

              <div className={styles.column}>
                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Мероприятие</p>
                    <p className={styles.infoTitle}>{moment(singleEvent.createdAt).format('DD.MM.YYYY')}</p>
                  </div>
                  <p className={styles.text}>
                    {singleEvent._id}
                  </p>
                </div>

                <div className={styles.infoBlock}>
                  <div className={styles.infoHeader}>
                    <p className={styles.infoTitle}>Фото</p>
                  </div>
                  <div className={styles.list}>
                    {[...singleEvent.carousel_photos].map((photo) => (
                      <img className={styles.photo} key={photo._id} src={Api.url + photo.preview_url} alt="ph" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
    </div>

  );
}

export default ViewSingleEvent;
